import React from 'react';
import clsx from 'clsx';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  error,
  className,
  id,
  ...props
}) => {
  const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-');
  
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={textareaId}
          className="block text-sm font-semibold text-brand-blue mb-2"
        >
          {label}
        </label>
      )}
      <textarea
        id={textareaId}
        className={clsx(
          'w-full px-4 py-3 border rounded-lg transition-colors',
          'focus:ring-2 focus:ring-brand-blue focus:border-transparent',
          error ? 'border-brand-red' : 'border-gray-300',
          className
        )}
        {...props}
      />
      {error && (
        <p className="text-brand-red text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

